import { BotDetectionService } from '@naturalcycles/js-lib'
import { env } from '@src/environments/environment.js'

export const botDetectionService = new BotDetectionService({
  enabled: !env.test, // disable in unit tests, so it doesn't scream
  memoizeResults: true,
  treatCDPAsBotReason: true,
})

export const isE2E = (): boolean => !!localStorage.getItem('e2e')
export const botReason = botDetectionService.getBotReason()
export const isCDP = botDetectionService.isCDP()
